<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <p>Completar Información</p>
  <button mat-mini-fab (click)="close(false)"><mat-icon>close</mat-icon></button>
</div>
<mat-dialog-content [ngClass]="{'loading': loading}">
  <div class="ctn-loading" *ngIf="loading">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

  <mat-stepper orientation="vertical">
    <mat-step
      [stepControl]="formStep1"
      errorMessage="Verifique el formulario"
      (interacted)="interseptedStep1()" 
    >
      <ng-template matStepLabel>Propiedad</ng-template>
      <form class="mt-12" [formGroup]="formStep1">
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de inicio de renta</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker"
                placeholder="Elige una fecha"
                formControlName="initial_date"
                required
              >
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de fin de renta</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker2"
                placeholder="Elige una fecha"
                formControlName="final_date"
                required
              >
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Banco</label>
            <mat-form-field appearance="outline">
              <mat-select placeholder="Selecciona un banco" formControlName="institution_bank_id">
                <mat-option *ngFor="let bank of institution" [value]="bank.id">
                  {{ bank.description }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">CLABE Interbancaria</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                placeholder="CLABE interbancaria (18 digitos)"
                formControlName="interbank_clabe"
                required
              >
            </mat-form-field>
          </div>
        </div>

        <div class="first mb-12" fxLayoutGap="24px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between start">
          <div fxFlex="50%" fxFlexFill>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="label-files">
                <label class="input" [ngClass]="{'invalid': outsideStep1 && formStep1.get('predial')!.invalid}">Documento predial</label>
                <a [href]="linkPredial" target="_blank" *ngIf="havePredial">Ver archivo</a>
            </div>
            <app-upload-file-simple
                [formats]="['png', 'jpg', 'jpeg', 'pdf', 'xlsx', 'xls', 'docx']"
                [labelInput]="havePredial ? 'Reemplazar archivo existente' : 'Arrastra y suelta o haz click para buscar tu(s) archivo'"
                [active]="validPredial"
                [uploadFileWithError]="true"
                (onClear)="clearPredial()"
                (onAddFile)="setPredial($event)"
            ></app-upload-file-simple>
          </div>
          <div fxFlex="50%" fxFlexFill>
              <div fxLayout="row" fxLayoutAlign="space-between center" class="label-files">
                  <label class="input" [ngClass]="{'invalid': outsideStep1 && formStep1.get('ine')!.invalid}">Identificación oficial</label>
                  <a [href]="linkIne" target="_blank" *ngIf="haveIne">Ver archivo</a>
              </div>
              <app-upload-file-simple
                  [formats]="['png', 'jpg', 'jpeg', 'pdf', 'docx']"
                  [labelInput]="haveIne ? 'Reemplazar archivo existente' : 'Arrastra y suelta o haz click para buscar tu(s) archivo'"
                  [active]="validIne"
                  [uploadFileWithError]="true"
                  (onClear)="clearIne()"
                  (onAddFile)="setIne($event)"
              ></app-upload-file-simple>
          </div>
        </div>

        <div
          class="first mb-12"
          fxLayoutGap="24px"
          fxLayout.gt-sm="row"
          fxLayout="column"
          fxLayoutAlign="center center"
          *ngIf="(!haveContract && continueWithCustomContract === true) || haveContract"
        >
          <div fxFlex="100" fxFlexFill>
            <div fxLayout="row" fxLayoutAlign="space-between center" class="label-files">
                <label class="input" [ngClass]="{'invalid': outsideStep1 && formStep1.get('contract')!.invalid}">Contrato de Renta</label>
                <a [href]="linkContract" target="_blank" *ngIf="haveContract">Ver archivo</a>
            </div>
            <app-upload-file-simple
                [formats]="['png', 'jpg', 'jpeg', 'pdf', 'xlsx', 'xls', 'docx']"
                [labelInput]="haveContract ? 'Reemplazar archivo existente' : 'Arrastra y suelta o haz click para buscar tu(s) archivo'"
                [active]="validContract"
                [uploadFileWithError]="true"
                (onClear)="clearContract()"
                (onAddFile)="setContract($event)"
            ></app-upload-file-simple>
          </div>
        </div>

        <div *ngIf="!haveContract && continueWithCustomContract === null" fxLayout="column" fxLayoutAlign="center center" [ngClass]="{'mat-elevation-z3': !haveContract}" class="not-have-contract-alert">
          <p>Notamos que no existe un contrato cargado para la renta de la propiedad, deseas:</p>
          <button mat-button (click)="setContinueWithCustomContract(true)">Subir un contrato firmado</button>
          <button mat-button class="mt-12" (click)="setContinueWithCustomContract(false)">Firmar un contrato digital Netta</button>
        </div>

        <ng-container *ngIf="!haveContract && continueWithCustomContract === false">
          <small class="mb-12">El monto se representara en la divisa de la propiedad*</small>

          <div class="mt-12" fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Deposito Inicial</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  type="number"
                  formControlName="deposito"
                >
              </mat-form-field>
            </div>

            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Mantenimiento</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  type="number"
                  formControlName="mantenimiento"
                >
              </mat-form-field>
            </div>
          </div>

          <label>Seleccione los servicios incluidos</label>

          <div class="list-services">
            <mat-checkbox formControlName="luz">Luz</mat-checkbox>
            <mat-checkbox formControlName="agua">Agua</mat-checkbox>
            <mat-checkbox formControlName="gas">Gas</mat-checkbox>
            <mat-checkbox formControlName="telephone">Teléfono</mat-checkbox>
          </div>

          <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Servicio Extra 1</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="servicio_extra1"
                >
              </mat-form-field>
            </div>

            <div fxFlex="50%" fxFlexFill fxLayout="column">
              <label class="input">Servicio Extra 2</label>
              <mat-form-field appearance="outline">
                <input
                  autocomplete="off"
                  matInput
                  formControlName="servicio_extra2"
                >
              </mat-form-field>
            </div>
          </div>

          <div class="list-services">
            <mat-checkbox formControlName="fiestas">Se permiten fiestas</mat-checkbox>
            <mat-checkbox formControlName="mascotas">Se permiten mascotas</mat-checkbox>
          </div>
        </ng-container>
      </form>

      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="!haveContract && continueWithCustomContract === false">
        <button mat-button matStepperNext>Siguiente</button>
      </div>

      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="haveContract || continueWithCustomContract === true">
        <button mat-button [disabled]="!validFormWithContract" *ngIf="!loadingSubmit" class="finalice" (click)="submitWithContract()">Finalizar</button>
        <mat-spinner [diameter]="30" *ngIf="loadingSubmit"></mat-spinner>
      </div>
    </mat-step>

    <mat-step [stepControl]="formStep2" *ngIf="!haveContract && continueWithCustomContract === false">
      <ng-template matStepLabel>Penalizaciones</ng-template>
      <form [formGroup]="formStep2">
        <div fxLayout="column" class="mt-12" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Pago retrasado</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                placeholder="n% del monto de un mes de renta"
                formControlName="retrasado"
                type="number"
              >
            </mat-form-field>
          </div>

          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">No aviso de daños en el inmueble</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                placeholder="equivalente a n meses de renta"
                type="number"
                formControlName="no_aviso"
              >
            </mat-form-field>
          </div>

          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Entrega en codiciones no aceptables</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                placeholder="equivalente a n meses de renta"
                type="number"
                formControlName="no_entrega"
              >
            </mat-form-field>
          </div>
        </div>
      </form>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button matStepperPrevious class="preview">Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>

    <mat-step [stepControl]="formStep3" *ngIf="!haveContract && continueWithCustomContract === false">
      <ng-template matStepLabel>Contrato</ng-template>
      <form class="mt-12" [formGroup]="formStep3">
        <div fxLayout="row" class="mb-12">
          <mat-slide-toggle formControlName="is_moral" (change)="changeMoralStep3($event)">Es una persona moral</mat-slide-toggle>
        </div>

        <div fxLayout="row" class="mb-24">
          <mat-slide-toggle formControlName="with_representate" (change)="changeWithRepresentate($event)">Cuenta con un representante legal</mat-slide-toggle>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Instrumento público número</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_instrumento_publico"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker3"
                formControlName="fecha_registro"
              >
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Licenciado que dio fe</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="licenciado"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Notaría pública</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_notaria_publica"
              >
            </mat-form-field>
          </div>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Ciudad de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="ciudad_registro"
              >
            </mat-form-field>
          </div>

          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Folio mercantil electrónico</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="folio_mercantil"
              >
            </mat-form-field>
          </div>
        </div>
      </form>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button matStepperPrevious class="preview">Anterior</button>
        <button mat-button matStepperNext>Siguiente</button>
      </div>
    </mat-step>

    <mat-step [stepControl]="formStep4" *ngIf="!haveContract && continueWithCustomContract === false">
      <ng-template matStepLabel>Representante Legal</ng-template>

      <form [formGroup]="formStep4">
        <div fxLayout="row" class="mb-24 mt-12">
          <mat-slide-toggle formControlName="is_moral" (change)="changeMoralStep4($event)">Es una persona moral</mat-slide-toggle>
        </div>

        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="100%" fxFlexFill fxLayout="column">
            <label class="input">Nombre Completo</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="full_name"
              >
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Instrumento público número</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_instrumento_publico"
              >
            </mat-form-field>
          </div>
  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Fecha de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                [matDatepicker]="picker4"
                formControlName="fecha_registro"
              >
              <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
              <mat-datepicker #picker4></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Licenciado que dio fe</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="licenciado"
              >
            </mat-form-field>
          </div>
  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Notaría pública</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="no_notaria_publica"
              >
            </mat-form-field>
          </div>
        </div>
  
        <div fxLayoutGap.gt-sm="24px" fxLayoutGap="0px" fxLayout.gt-sm="row" fxLayout="column" fxLayoutAlign="space-between center">  
          <div fxFlex="50%" fxFlexFill fxLayout="column">
            <label class="input">Ciudad de Registro</label>
            <mat-form-field appearance="outline">
              <input
                autocomplete="off"
                matInput
                formControlName="ciudad_registro"
              >
            </mat-form-field>
          </div>
        </div>
      </form>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-button matStepperPrevious class="preview">Anterior</button>
        <button
          mat-button
          matStepperNext
          [disabled]="formStep1.invalid"
          (click)="submit()"
          *ngIf="!loadingSubmit"
        >Finalizar</button>

        <mat-spinner [diameter]="30" *ngIf="loadingSubmit"></mat-spinner>
      </div>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>